import React, { useContext } from "react";

import Loading from "ui/Loading";

import {
  WithAppConfigQuery,
  useWithAppConfigQuery,
} from "./gql/Query.generated";

export type AppConfigType = Omit<
  WithAppConfigQuery["getAppConfig"],
  "__typename" | "id"
>;

export const AppConfigContext = React.createContext<AppConfigType | undefined>(
  undefined,
);

const WithAppConfig = ({ children }: { children: React.ReactNode }) => {
  const { loading, data, error } = useWithAppConfigQuery();

  if (loading || error || !data) {
    return <Loading error={!!error} />;
  }

  return (
    <AppConfigContext.Provider value={data.getAppConfig}>
      {children}
    </AppConfigContext.Provider>
  );
};

export function useAppConfig(): AppConfigType {
  const config = useContext(AppConfigContext);
  if (!config) {
    throw new Error("must have ancestor WithAppConfig component");
  }
  return config;
}

export default WithAppConfig;
